import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, ArrowUp } from 'lucide-react';
import { Button } from './ui/button';

export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-12 border-t border-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
              <span className="text-xl font-heading font-bold gradient-text">
                Seth Cushing
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              AI Transformation Leader | Enterprise Architect
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full hover:bg-blue/10 hover:text-blue"
              asChild
              data-testid="footer-linkedin"
            >
              <a href="https://www.linkedin.com/in/seth-cushing-cap-pmp-aipo-259ba1124/" target="_blank" rel="noopener noreferrer">
                <Linkedin className="w-5 h-5" />
              </a>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full hover:bg-teal/10 hover:text-teal"
              asChild
              data-testid="footer-email"
            >
              <a href="mailto:contact@sethcushing.com">
                <Mail className="w-5 h-5" />
              </a>
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="rounded-full border-teal/30 hover:bg-teal/10"
              onClick={scrollToTop}
              data-testid="footer-scroll-top"
            >
              <ArrowUp className="w-5 h-5" />
            </Button>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="mt-8 pt-8 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            Built with modern AI-first architecture principles. 
            Crafted for enterprise transformation leaders.
          </p>
        </div>
      </div>
    </footer>
  );
}
